import { Component, inject, OnInit, ChangeDetectionStrategy, signal } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { PersonService } from "../../services/person-service";
import { Person } from "../../person/person";
import { Entity } from "../../entity/entity";
import { ShippingChargeService } from "../../services/shipping-charge.service";
import { HttpErrorResponse } from "@angular/common/http";
import { StringUtils } from "../../utils/string-utils";
import { MatButton } from "@angular/material/button";
import { Organization } from "../../organization/organization";
import { OrganizationService } from "../../services/organization-service";
import { EntityUtils } from "../../utils/entity-utils";

@Component({
  selector: "app-create-shipping-charge-task-dialog",
  imports: [
    MatButton
  ],
  templateUrl: "./create-shipping-charge-task-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: "./create-shipping-charge-task-dialog.component.css"
})
export class CreateShippingChargeTaskDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<CreateShippingChargeTaskDialogComponent>>(MatDialogRef);
  private readonly personService = inject(PersonService);
  private readonly shippingChargeService = inject(ShippingChargeService);
  private readonly organizationService: OrganizationService = inject(OrganizationService);
  private readonly data = inject(MAT_DIALOG_DATA);
  readonly salesRep = signal<Person>(undefined!);
  salesEntity!: Entity;
  readonly repOffice = signal<Organization>(undefined!);
  readonly errorMessage = signal<string | undefined>(undefined);
  readonly isBusy = signal(false);

  ngOnInit(): void {
    this.isBusy.set(true);
    this.errorMessage.set(undefined);
    this.salesEntity = this.data.entity;
    this.organizationService.getOrganization(this.salesEntity.repOfficeId).subscribe({
      next: (org: Organization) => {
        this.repOffice.set(org);
        this.personService.getContactPerson(this.salesEntity.salesRepId).subscribe({
          next: (rep: Person) => {
            this.salesRep.set(rep);
            this.isBusy.set(false);
          }, error: (error: HttpErrorResponse) => this.handleError(error)
        });
      }, error: (error: HttpErrorResponse) => this.handleError(error)
    });
  }

  private handleError(error: HttpErrorResponse): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  createTask(): void {
    this.errorMessage.set(undefined);
    this.isBusy.set(true);
    this.shippingChargeService.createTask(this.salesEntity.id).subscribe({
      next: (response: string) => {
        this.isBusy.set(false);
        this.dialogRef.close(response);
      }, error: (error: HttpErrorResponse) => this.handleError(error)
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  getConfiguredQuantity(): number {
    return EntityUtils.getConfiguredQuantity(this.salesEntity);
  }

}
